
import { addHoliday, deleteHoliday, getHolidayById, getHolidays, updateHoliday } from "app/redux/api";
import { FAILURE, REQUEST, SUCCESS, HOLIDAYS_ACTION_TYPE } from "../utilities";

export const CREATE_HOLIDAY = (data, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(HOLIDAYS_ACTION_TYPE.CREATE_REQUEST));
    addHoliday(data, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(HOLIDAYS_ACTION_TYPE.CREATE_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        HOLIDAYS_ACTION_TYPE.CREATE_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(HOLIDAYS_ACTION_TYPE.CREATE_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const GET_ALL_HOLIDAY = (filters, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(HOLIDAYS_ACTION_TYPE.GET_REQUEST));

    getHolidays(filters, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(HOLIDAYS_ACTION_TYPE.GET_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        HOLIDAYS_ACTION_TYPE.GET_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(HOLIDAYS_ACTION_TYPE.GET_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const GET_BY_ID_HOLIDAY = (id, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(HOLIDAYS_ACTION_TYPE.GET_BY_ID_REQUEST));

    getHolidayById(id, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(HOLIDAYS_ACTION_TYPE.GET_BY_ID_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        HOLIDAYS_ACTION_TYPE.GET_BY_ID_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(HOLIDAYS_ACTION_TYPE.GET_BY_ID_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const UPDATE_HOLIDAY = (id, data, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(HOLIDAYS_ACTION_TYPE.UPDATE_REQUEST));

    updateHoliday(id, data, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(HOLIDAYS_ACTION_TYPE.UPDATE_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        HOLIDAYS_ACTION_TYPE.UPDATE_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(HOLIDAYS_ACTION_TYPE.UPDATE_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const DELETE_HOLIDAY = (id,  token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(HOLIDAYS_ACTION_TYPE.REMOVE_REQUEST));

    deleteHoliday(id,  token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(HOLIDAYS_ACTION_TYPE.REMOVE_SUCCESS, id)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        HOLIDAYS_ACTION_TYPE.REMOVE_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(HOLIDAYS_ACTION_TYPE.REMOVE_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};
